import { type IFilter } from "@/src/shared/features/search";
import { formatYearDate } from "@/src/shared/utils/timeFunctionsModel";
import type { IListingPriceParams } from "./types";

const toCount = (value: unknown) => (value ? Number(value) || 0 : 0);

export const listingService = {
  /** Listing id from `?listing_id=` or the `/listing/{id}` path; null when neither has one. */
  listingIdFromRoute(
    query: Record<string, unknown>,
    asPath: string,
  ): string | null {
    const fromQuery = query.listing_id;
    if (typeof fromQuery === "string" && fromQuery) return fromQuery;
    const fromPath = asPath.split("/listing/")[1]?.split("?")[0];
    return fromPath || null;
  },

  /** Price params for the filters: all guests counted, at least 1; dates as YYYY-MM-DD. */
  buildPriceParams(
    filters: IFilter,
    listingId: string | null,
  ): IListingPriceParams | null {
    if (!listingId) return null;
    const guests =
      toCount(filters.guests?.adults) +
      toCount(filters.guests?.children) +
      toCount(filters.guests?.infants);
    return {
      guest: guests > 0 ? guests : 1,
      // No date keeps its original falsy value, exactly as the API has always received it.
      from: (filters.checkIn && formatYearDate(filters.checkIn)) as string,
      to: (filters.checkOut && formatYearDate(filters.checkOut)) as string,
      listing_id: Number(listingId),
    };
  },
};
